import { render, staticRenderFns } from "./IntervenantView.vue?vue&type=template&id=0fa8df54&scoped=true&"
import script from "./IntervenantView.vue?vue&type=script&lang=js&"
export * from "./IntervenantView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa8df54",
  null
  
)

export default component.exports